// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"hourglass"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M19 21H5V19C5 15.134 8.13401 12 12 12C15.866 12 19 15.134 19 19V21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M5 3H19V5C19 8.86599 15.866 12 12 12C8.13401 12 5 8.86599 5 5V3Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 12C15.866 12 19 15.134 19 19V21H5V19C5 15.134 8.13401 12 12 12ZM12 12C8.13401 12 5 8.86599 5 5V3H19V5C19 8.86599 15.866 12 12 12Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-hourglass')
export default class HourglassIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'hourglass',
    }
  }
}
